/* The Scribble Bot · theme JS (buy box, sticky bar, UGC videos, tap-to-drop popup). No dependencies.
   Works with Dawn's cart drawer when it is enabled (Theme settings → Cart → Drawer). */
(function () {
  "use strict";

  /* ---------- money ---------- */
  function money(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    return (fmt || "A${{amount}}")
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","))
      .replace(/<[^>]+>/g, "");
  }

  /* ---------- cart ---------- */
  function refreshCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("#cartN").forEach(function (n) { n.textContent = cart.item_count; });
        return cart;
      });
  }
  function addToCart(variantId, quantity) {
    var drawer = document.querySelector("cart-drawer");
    var notice = document.querySelector("cart-notification");
    var target = drawer || notice;
    var body = { items: [{ id: variantId, quantity: quantity || 1 }] };
    if (target && typeof target.getSectionsToRender === "function") {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) { throw new Error(res.description || res.message || "Could not add to cart"); }
      var rendered = false;
      if (target && typeof target.renderContents === "function" && res.sections) {
        // Dawn's product-form does this before renderContents: the drawer keeps hiding its header/footer otherwise
        if (target.classList.contains("is-empty")) target.classList.remove("is-empty");
        try { target.renderContents(res); rendered = true; } catch (e) { /* drawer markup differs: fall through */ }
      }
      if (rendered) return res;
      return refreshCount().then(function () { return res; });
    });
  }

  /* ---------- buy box ---------- */
  function initBuy(root) {
    var data = JSON.parse(root.querySelector("[data-sb-buy-data]").textContent);
    var fmt = data.moneyFormat;
    var st = { slide: 0, col: null, tier: 1, per: { 2: [], 3: [] }, variant: null };
    var main = root.querySelector(".gal-img"), count = root.querySelector(".gal-count");
    var thumbs = root.querySelectorAll(".thumb"), dots = root.querySelectorAll(".dots i");
    var swatches = root.querySelectorAll(".swatch");
    var colours = [].map.call(swatches, function (s) { return s.dataset.col; });
    var single = data.single;
    var threshold = +root.dataset.threshold;
    var stockEl = root.querySelector("[data-stock]"), stockN = root.querySelector("[data-stock-n]");
    var stockMode = root.dataset.stockMode || "real";
    var atc = root.querySelector(".atc"), atcLabel = root.querySelector("[data-atc-label]");
    var variantInput = root.querySelector("[data-variant-input]");
    var sbar = document.getElementById("sbar-" + root.dataset.section);

    function variantFor(col) { return single.find(function (v) { return v.option1 === col; }) || single[0]; }
    function bundleVariant(n) {
      var list = n === 2 ? data.pair : data.trio;
      var want = st.per[n].map(function (c) { return String(c).toLowerCase(); }).join("|");
      return list.find(function (v) { return (v.options || []).map(function (o) { return String(o).toLowerCase(); }).join("|") === want; })
        || list.find(function (v) { return v.available; }) || list[0];
    }
    function show(i) {
      var n = data.media.length; if (!n) return;
      st.slide = (i + n) % n;
      main.src = data.media[st.slide].src; main.removeAttribute("srcset"); main.alt = data.media[st.slide].alt || "";
      thumbs.forEach(function (b, j) { b.setAttribute("aria-current", j === st.slide ? "true" : "false"); });
      dots.forEach(function (d, j) { d.className = j === st.slide ? "on" : ""; });
      if (count) count.textContent = (st.slide + 1) + " / " + n;
    }
    function mediaIndexFor(variantId) {
      var mid = data.variantMedia[variantId]; if (!mid) return 0;
      var idx = data.media.findIndex(function (m) { return m.id === mid; }); return idx < 0 ? 0 : idx;
    }
    function current() {
      if (st.tier === 1) return { v: variantFor(st.col), qty: 1 };
      return { v: bundleVariant(st.tier), qty: 1 };
    }
    function render() {
      var c = current(), v = c.v;
      st.variant = v;
      root.querySelector("[data-price]").textContent = v ? money(v.price, fmt) : "";
      // "was" and "save": the 2- and 3-packs against N single robots; the single against its compare-at price
      var wasEl = root.querySelector("[data-was]"), saveEl = root.querySelector("[data-save]");
      var was = 0;
      if (v) { was = st.tier === 1 ? (data.singleCompareAt || 0) : data.singlePrice * st.tier; }
      var saving = v ? was - v.price : 0;
      if (wasEl && saveEl) {
        if (saving > 0) { wasEl.textContent = money(was, fmt); saveEl.textContent = "Save " + money(saving, fmt); wasEl.hidden = false; saveEl.hidden = false; }
        else { wasEl.hidden = true; saveEl.hidden = true; }
      }
      variantInput.value = v ? v.id : "";
      var ok = v && v.available;
      atc.disabled = !ok;
      atcLabel.textContent = ok ? "Add to cart — " + money(v.price, fmt) : "Sold out";
      // urgency line: "real" mode shows the true count of the selected colour only when 0 < stock <= threshold
      var sv = variantFor(st.col), q = sv ? data.stock[sv.id] : null;
      if (stockEl) {
        if (stockMode === "real") {
          var showStock = q !== null && q !== undefined && q > 0 && q <= threshold;
          stockEl.hidden = !showStock; if (showStock) stockN.textContent = q;
          var sr = stockEl.querySelector("[data-stock-real]"); if (sr) sr.hidden = !showStock;
        }
      }
      if (sbar) {
        sbar.querySelector("[data-sbar-pr]").textContent = v ? (money(v.price, fmt) + " · " + (st.tier === 1 ? st.col : (st.tier + " Scribble Bots"))) : "";
        sbar.querySelector("[data-sbar-img]").src = data.media[mediaIndexFor(sv ? sv.id : 0)] ? data.media[mediaIndexFor(sv ? sv.id : 0)].src : "";
      }
    }
    function renderPer() {
      root.querySelectorAll(".percol").forEach(function (pc) {
        var n = +pc.dataset.n; pc.innerHTML = "";
        st.per[n].forEach(function (c, k) {
          var wrap = document.createElement("span"); wrap.style.cssText = "display:inline-flex;align-items:center;gap:6px";
          wrap.appendChild(document.createTextNode("Robot " + (k + 1)));
          var seg = document.createElement("span"); seg.className = "seg";
          colours.forEach(function (col) {
            var b = document.createElement("button"); b.type = "button"; b.textContent = col;
            b.setAttribute("aria-pressed", col === c ? "true" : "false");
            b.addEventListener("click", function (e) { e.stopPropagation(); st.per[n][k] = col; renderPer(); render(); });
            seg.appendChild(b);
          });
          wrap.appendChild(seg); pc.appendChild(wrap);
        });
      });
    }
    function setTier(n) {
      st.tier = n;
      root.querySelectorAll(".tier").forEach(function (t) { t.setAttribute("aria-checked", +t.dataset.tier === n ? "true" : "false"); });
      render();
    }
    // init state
    st.col = colours[0] || (single[0] && single[0].option1);
    st.per[2] = [colours[0], colours[1] || colours[0]];
    st.per[3] = [colours[0], colours[1] || colours[0], colours[0]];
    thumbs.forEach(function (b, i) { b.addEventListener("click", function () { show(i); }); });
    var prev = root.querySelector(".gal-arrow.prev"), next = root.querySelector(".gal-arrow.next");
    if (prev) prev.addEventListener("click", function () { show(st.slide - 1); });
    if (next) next.addEventListener("click", function () { show(st.slide + 1); });
    var x0 = null, gm = root.querySelector(".gal-main");
    gm.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gm.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(st.slide + (dx < 0 ? 1 : -1)); });
    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        st.col = sw.dataset.col;
        swatches.forEach(function (o) { o.setAttribute("aria-pressed", o === sw ? "true" : "false"); });
        var cn = root.querySelector("[data-col-name]"); if (cn) cn.textContent = st.col;
        show(mediaIndexFor(variantFor(st.col).id)); render();
      });
    });
    root.querySelectorAll(".tier").forEach(function (t) { t.addEventListener("click", function () { setTier(+t.dataset.tier); }); });
    renderPer(); render();

    // add to cart (form submit + sticky bar)
    function add() {
      if (!st.variant || !st.variant.available) return;
      atc.classList.add("is-loading"); var was = atcLabel.textContent;
      addToCart(st.variant.id, 1).then(function () {
        atcLabel.textContent = "Added to cart"; setTimeout(function () { atcLabel.textContent = was; atc.classList.remove("is-loading"); }, 1400);
      }).catch(function (err) {
        atc.classList.remove("is-loading"); atcLabel.textContent = err.message || "Couldn’t add — try again"; setTimeout(function () { atcLabel.textContent = was; }, 2500);
      });
    }
    root.querySelector("[data-atc-form]").addEventListener("submit", function (e) { e.preventDefault(); add(); });
    if (sbar) {
      sbar.querySelector("[data-sbar-btn]").addEventListener("click", add);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sbar.classList.toggle("on", past); sbar.setAttribute("aria-hidden", past ? "false" : "true");
        });
      });
      io.observe(atc);
    }
    // buttons elsewhere on the page: data-sb-tier="3" jumps to the buy box with that tier; data-sb-add adds the current selection
    document.querySelectorAll("[data-sb-tier]").forEach(function (b) {
      b.addEventListener("click", function () { setTier(+b.dataset.sbTier); root.scrollIntoView({ behavior: "smooth", block: "start" }); });
    });
    document.querySelectorAll("[data-sb-add]").forEach(function (b) { b.addEventListener("click", add); });
  }
  document.querySelectorAll(".sb-buy").forEach(initBuy);

  /* ---------- UGC videos: muted autoplay, one sound on at a time ---------- */
  var cards = document.querySelectorAll(".ugc-card");
  function setSound(card, on) {
    var v = card.querySelector("video"), b = card.querySelector(".snd"); if (!v || !b) return;
    v.muted = !on; b.setAttribute("aria-pressed", on ? "true" : "false"); b.setAttribute("aria-label", on ? "Turn sound off" : "Turn sound on");
    if (on) { try { v.currentTime = 0; } catch (e) {} v.play().catch(function () {}); }
  }
  cards.forEach(function (card) {
    var b = card.querySelector(".snd"); if (!b) return;
    b.addEventListener("click", function () {
      var on = card.querySelector("video").muted;
      cards.forEach(function (c) { if (c !== card) setSound(c, false); });
      setSound(card, on);
    });
  });
  if ("IntersectionObserver" in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); if (!v.muted) setSound(v.closest(".ugc-card"), false); }
      });
    }, { threshold: 0.35 });
    document.querySelectorAll(".ugc-card video").forEach(function (v) { vio.observe(v); });
  }

  /* ---------- tap to drop (discount pachinko) ---------- */
  (function () {
    var box = document.getElementById("sbDrop"); if (!box) return;
    var tab = document.querySelector("[data-drop-tab]");
    var prizes = JSON.parse(box.querySelector("[data-drop-prizes]").textContent).filter(function (p) { return p.label; });
    if (!prizes.length) return;
    var KEY = "sb_drop", days = +box.dataset.days || 7, delay = (+box.dataset.delay || 8) * 1000, exitIntent = box.dataset.exit === "true";
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var state = read(), opened = false, playing = false;
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch (e) { return {}; } }
    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
    var canvas = box.querySelector("canvas"), ctx = canvas.getContext("2d");
    var W = canvas.width, H = canvas.height, COLS = prizes.length, ROWS = 6, colW = W / COLS, R = 11;
    var slotsEl = box.querySelector("[data-drop-slots]");
    slotsEl.style.gridTemplateColumns = "repeat(" + COLS + ",1fr)";
    prizes.forEach(function (p) { var sp = document.createElement("span"); sp.textContent = p.label; slotsEl.appendChild(sp); });
    var form = box.querySelector("[data-drop-form]"), email = box.querySelector("#sbDropEmail"), err = box.querySelector("[data-drop-err]");
    var prizeEl = box.querySelector("[data-drop-prize]"), codeEl = box.querySelector("[data-drop-code]"), copied = box.querySelector("[data-drop-copied]");

    function pegRows() {
      var rows = [], top = 34, bottom = H - 62;
      for (var r = 0; r < ROWS; r++) {
        var y = top + r * ((bottom - top) / (ROWS - 1));
        var centre = r % 2 === 0, xs = [];
        for (var i = 0; i < (centre ? COLS : COLS + 1); i++) xs.push(centre ? (i + 0.5) * colW : i * colW);
        rows.push({ y: y, xs: xs });
      }
      return rows;
    }
    var rows = pegRows();
    function draw(ball, hit) {
      ctx.clearRect(0, 0, W, H);
      // slot dividers
      ctx.strokeStyle = "rgba(255,255,255,.28)"; ctx.lineWidth = 2;
      for (var c = 1; c < COLS; c++) { ctx.beginPath(); ctx.moveTo(c * colW, H - 44); ctx.lineTo(c * colW, H); ctx.stroke(); }
      if (hit !== undefined && hit !== null) { ctx.fillStyle = "rgba(238,90,54,.28)"; ctx.fillRect(hit * colW + 2, H - 44, colW - 4, 44); }
      // pegs
      rows.forEach(function (row) { row.xs.forEach(function (x) {
        if (x <= 0 || x >= W) return;
        ctx.beginPath(); ctx.arc(x, row.y, 4.5, 0, Math.PI * 2); ctx.fillStyle = "rgba(255,255,255,.82)"; ctx.fill();
      }); });
      if (ball) {
        // the marker: coral body, ink cap, a soft shadow
        ctx.beginPath(); ctx.arc(ball.x, ball.y + 3, R, 0, Math.PI * 2); ctx.fillStyle = "rgba(0,0,0,.28)"; ctx.fill();
        ctx.beginPath(); ctx.arc(ball.x, ball.y, R, 0, Math.PI * 2); ctx.fillStyle = "#EE5A36"; ctx.fill();
        ctx.beginPath(); ctx.arc(ball.x - 3.5, ball.y - 3.5, 3.5, 0, Math.PI * 2); ctx.fillStyle = "rgba(255,255,255,.55)"; ctx.fill();
      }
    }
    function pick() {
      var total = prizes.reduce(function (a, p) { return a + (+p.w || 0); }, 0);
      if (total <= 0) return Math.floor(Math.random() * COLS);
      var r = Math.random() * total;
      for (var i = 0; i < COLS; i++) { r -= (+prizes[i].w || 0); if (r < 0) return i; }
      return COLS - 1;
    }
    function path(target) {
      // start at the middle column; each peg row deflects half a column left or right; the deflections are
      // shuffled so the fall looks random, but they always add up to the winning slot
      var startCol = Math.floor(COLS / 2), need = target - startCol; // sum of ±0.5 steps over ROWS rows
      var plus = (need * 2 + ROWS) / 2; // number of +0.5 steps
      var steps = [];
      for (var i = 0; i < ROWS; i++) steps.push(i < plus ? 0.5 : -0.5);
      for (var j = steps.length - 1; j > 0; j--) { var k = Math.floor(Math.random() * (j + 1)); var t = steps[j]; steps[j] = steps[k]; steps[k] = t; }
      var pts = [{ x: (startCol + 0.5) * colW, y: -R }], col = startCol + 0.5;
      steps.forEach(function (d, r) { col += d; pts.push({ x: Math.min(W - R - 2, Math.max(R + 2, col * colW)), y: rows[r].y + 6 }); });
      pts.push({ x: (target + 0.5) * colW, y: H - 22 });
      return pts;
    }
    function animate(pts, done) {
      if (reduce) { draw(pts[pts.length - 1]); return done(); }
      var seg = 0, t0 = null, per = 230;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / (seg === pts.length - 2 ? 320 : per));
        var a = pts[seg], b = pts[seg + 1];
        var e = p * p; // accelerate into each peg
        var x = a.x + (b.x - a.x) * (0.5 - Math.cos(p * Math.PI) / 2), y = a.y + (b.y - a.y) * e;
        draw({ x: x, y: y });
        if (p < 1) return requestAnimationFrame(frame);
        seg++; t0 = null;
        if (seg < pts.length - 1) return requestAnimationFrame(frame);
        done();
      }
      requestAnimationFrame(frame);
    }
    function applyCode(code) {
      try { fetch("/discount/" + encodeURIComponent(code), { credentials: "same-origin" }).catch(function () {}); } catch (e) {}
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(function () { copied.hidden = false; }, function () {});
    }
    function showWin(p) {
      box.classList.add("won");
      prizeEl.textContent = p.label; codeEl.textContent = p.code;
      applyCode(p.code);
    }
    function saveEmail(addr) {
      var fd = new URLSearchParams();
      fd.append("form_type", "customer"); fd.append("utf8", "✓");
      fd.append("contact[email]", addr); fd.append("contact[tags]", "drawing-club,tap-to-drop");
      try { fetch("/contact", { method: "POST", body: fd, credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded" } }).catch(function () {}); } catch (e) {}
    }
    function play() {
      if (playing) return;
      var addr = (email.value || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { err.hidden = false; email.classList.add("shake"); setTimeout(function () { email.classList.remove("shake"); }, 450); email.focus(); return; }
      err.hidden = true; playing = true;
      saveEmail(addr);
      var target = pick();
      animate(path(target), function () {
        draw({ x: (target + 0.5) * colW, y: H - 22 }, target);
        slotsEl.children[target].classList.add("hit");
        state.won = { label: prizes[target].label, code: prizes[target].code, at: Date.now() }; save();
        setTimeout(function () { showWin(prizes[target]); tabWon(); }, 900);
      });
    }
    function tabWon() { if (!tab || !state.won) return; tab.querySelector("span").textContent = "Your code: " + state.won.code; tab.hidden = false; }
    function open() {
      if (opened && box.classList.contains("on")) return;
      var drawer = document.querySelector("cart-drawer"); if (drawer && drawer.classList.contains("active")) return;
      opened = true; box.hidden = false; box.classList.add("on"); document.body.classList.add("sb-drop-open");
      if (state.won) { showWin(state.won); } else { state.seen = Date.now(); save(); draw({ x: (Math.floor(COLS / 2) + 0.5) * colW, y: 16 }); setTimeout(function () { email.focus(); }, 60); }
      if (tab) tab.hidden = true;
    }
    function close() {
      box.classList.remove("on"); box.hidden = true; document.body.classList.remove("sb-drop-open");
      if (tab) { if (state.won) tabWon(); else tab.hidden = false; }
    }
    form.addEventListener("submit", function (e) { e.preventDefault(); play(); });
    box.querySelector("[data-drop-close]").addEventListener("click", close);
    box.addEventListener("click", function (e) { if (e.target === box) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && box.classList.contains("on")) close(); });
    codeEl.addEventListener("click", function () { applyCode(codeEl.textContent); });
    if (tab) tab.addEventListener("click", open);
    var fresh = !state.seen || (Date.now() - state.seen > days * 864e5);
    if (state.won) { if (Date.now() - (state.won.at || 0) < days * 864e5) tabWon(); }
    else if (fresh) {
      setTimeout(open, delay);
      if (exitIntent) document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0 && !opened) open(); });
    } else if (tab) { tab.hidden = false; }
  })();

  /* ---------- smooth anchors ---------- */
  document.addEventListener("click", function (e) {
    var s = e.target.closest("[data-scroll]"); if (!s) return;
    var el = document.getElementById(s.dataset.scroll); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: "smooth", block: "start" }); }
  });
})();
